module.exports = "<ng-content></ng-content>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/widget/widget.component.html
// module id = ./src/app/core/components/widget/widget.component.html
// module chunks = main